import React from 'react'
import useItems from '../../../hooks/use-locations'
import { find } from 'lodash'

const LabelItem = ({ locationId }) => {
    const [ locations ] = useItems()
    const item = find(locations, { id: locationId })
    const name = item ? item.name : ''
    return (
        <React.Fragment>{name}</React.Fragment>
    )
}

export default LabelItem